import ACTIONS from "../constants/actions";

const { GET_STATUS_REQUEST, GET_STATUS_SUCCESS, GET_STATUS_FAIL } = ACTIONS;

const initialState = {
  isLoadingGetStatus: false,
  status: [],
};

const statusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STATUS_REQUEST:
      return {
        ...state,
        isLoadingGetStatus: true,
      };
    case GET_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingGetStatus: false,
        status: action.payload,
      };
    case GET_STATUS_FAIL:
      return {
        isLoadingGetStatus: false,
        ...state,
      };
    default:
      return state;
  }
};
export default statusReducer;
